import type { ReactNode } from "react";
import { Check } from "lucide-react";
import s from "./ChoiceRow.module.css";

export interface ChoiceRowProps {
  selected: boolean;
  onSelect: () => void;
  children: ReactNode;
  /**
   * "radio" for a single-select step that auto-advances on tap, "checkbox"
   * for a multi-select one. Real ARIA roles rather than `aria-pressed`
   * buttons: a screen reader should hear "one of two" or "not checked", not
   * "pressed", because that is what the question actually is.
   */
  role: "radio" | "checkbox";
}

export function ChoiceRow({ selected, onSelect, children, role }: ChoiceRowProps) {
  return (
    <button
      type="button"
      role={role}
      aria-checked={selected}
      className={selected ? `${s.root} ${s.selected}` : s.root}
      onClick={onSelect}
    >
      <span className={s.label}>{children}</span>
      <Check aria-hidden className={s.check} size={18} />
    </button>
  );
}
